// Date format fallbacks for when translations haven't loaded yet
// These keys are used by flatpickr/design-system DatePickerInput
// and must return valid format strings (not the key itself)
export const DATE_FORMAT_FALLBACKS: Record<string, string> = {
  'date.formats.alt_format': 'm/d/Y',
  'date.formats.default': '%m/%d/%Y',
  'date.formats.date_picker': 'MM/DD/YYYY',
};
